import React, { useState } from "react";
import MonthlyGraphPopup from "./MonthlyGraphPopup";

export const StatisticsDashboard = ({
  aggregates,
  products,
  filters,
  onFetchMonthlyData,
}) => {
  const [isGraphPopupOpen, setIsGraphPopupOpen] = useState(false);
  const [monthlyData, setMonthlyData] = useState([]);
  const [isLoadingMonthlyData, setIsLoadingMonthlyData] = useState(false);

  // Return null if no aggregates or products
  if (!aggregates || !products || products.length === 0) {
    return null;
  }

  const handleGraphButtonClick = async () => {
    setIsLoadingMonthlyData(true);
    try {
      const data = await onFetchMonthlyData(filters);
      setMonthlyData(data);
      setIsGraphPopupOpen(true);
    } catch (error) {
      console.error("Error fetching monthly data:", error);
    } finally {
      setIsLoadingMonthlyData(false);
    }
  };

  const handleCloseGraphPopup = () => {
    setIsGraphPopupOpen(false);
  };

  return (
    <div
      className="row mt-3"
      style={{
        position: "sticky",
        bottom: "0",
        zIndex: 1000,
        backgroundColor: "white",
        paddingTop: "10px",
        marginTop: "20px",
        // borderTop: "2px solid #e9ecef",
      }}
    >
      <div className="col-12">
        <div
          className="card border"
          style={{
            backgroundColor: "#e8f4fd",
            borderColor: "#b3d9ff",
            boxShadow: "0 -2px 10px rgba(0,0,0,0.1)",
            height: "70px",
          }}
        >
          <div className="card-body py-2" style={{ height: "100%" }}>
            <div
              className="row align-items-center h-100"
              style={{
                minHeight: "50px",
                maxHeight: "60px",
              }}
            >
              {/* 1. Graph Column - Graph Button */}
              <div className="col-1 text-center">
                <button
                  className={`
                    tw-py-1 tw-px-2 tw-min-w-[70px] tw-text-[11px] tw-font-bold tw-rounded-md 
                    tw-border-2 tw-border-indigo-600
                    tw-shadow-lg tw-transition-all tw-duration-200 tw-ease-in-out 
                    ${
                      isLoadingMonthlyData
                        ? "tw-bg-[#f8f9fa] tw-text-[#6c757d] tw-cursor-wait"
                        : "tw-bg-[#4096ff] tw-text-[#ffffff] tw-cursor-pointer tw-hover:bg-blue-200"
                    }`}
                  onClick={handleGraphButtonClick}
                  disabled={isLoadingMonthlyData}
                  title="Показать графики месячной аналитики"
                >
                  {isLoadingMonthlyData ? (
                    <div className="d-flex align-items-center justify-content-center">
                      <div
                        className="spinner-border spinner-border-sm me-1"
                        role="status"
                        style={{ width: "10px", height: "10px" }}
                      >
                        <span className="visually-hidden">Загрузка...</span>
                      </div>
                      <span style={{ fontSize: "9px" }}>Итого</span>
                    </div>
                  ) : (
                    <div className="d-flex align-items-center justify-content-center">
                      <span style={{ fontSize: "12px", marginRight: "2px" }}>
                        <svg
                          width="15"
                          height="15"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M3 3v18h18"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="m19 9-5 5-4-4-3 3"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </span>
                      <span>Итого</span>
                    </div>
                  )}
                </button>
              </div>

              {/* 2. Brand Column - Empty */}
              <div className="col-1 text-center">
                <span className="text-muted" style={{ fontSize: "12px" }}>
                  -
                </span>
              </div>

              {/* 3. Image Column - Empty */}
              <div className="col-1 text-center">
                <span className="text-muted" style={{ fontSize: "12px" }}>
                  -
                </span>
              </div>

              {/* 4. Product Details Column - Total Products */}
              <div className="col-2 text-center">
                <span
                  className="fw-bold text-primary"
                  style={{ fontSize: "12px" }}
                >
                  {/* {aggregates.total_products?.toLocaleString() || 0} товаров */}
                </span>
              </div>

              {/* 5. Category Column - Empty */}
              <div className="col-1 text-center">
                <span className="text-muted" style={{ fontSize: "12px" }}>
                  -
                </span>
              </div>

              {/* 6. Subcategory Column - Empty */}
              <div className="col-1 text-center">
                <span className="text-muted" style={{ fontSize: "12px" }}>
                  -
                </span>
              </div>

              {/* 7. Subgroup Column - Empty */}
              <div className="col-1 text-center">
                <span className="text-muted" style={{ fontSize: "12px" }}>
                  -
                </span>
              </div>

              <div className="col-1 text-center d-flex flex-column justify-content-center">
                {/* Title */}
                <div className="tw-text-[7px] md:tw-text-[9px] tw-font-bold">
                  общ. продавцы
                </div>
                {/* Value */}
                <div className="tw-text-[8px] tw-pt-1 tw-text-blue-400 tw-font-bold">
                  {aggregates.total_sellers?.toLocaleString() || 0}
                </div>
              </div>

              {/* 8. Price Column - Average Price */}
              <div className="col-1 text-center d-flex flex-column justify-content-center">
                {/* Title */}
                <div className="tw-text-[7px] md:tw-text-[9px] tw-font-bold">
                  ср.цена
                </div>
                {/* Value */}
                <div className="tw-text-[8px] tw-pt-1 tw-text-blue-400 tw-font-bold">
                  {aggregates.avg_price
                    ? `${aggregates.avg_price.toLocaleString()} ₸`
                    : "0 ₸"}
                </div>
              </div>

              {/* 9. Orders Column - Total Orders */}
              <div className="col-1 text-center d-flex flex-column justify-content-center">
                {/* Title */}
                <div className="tw-text-[7px] md:tw-text-[9px] tw-font-bold">
                  общ. продажи
                </div>
                {/* Value */}
                <div className="tw-text-[6px] md:tw-text-[8px] tw-pt-1 tw-text-blue-400 tw-font-bold">
                  {aggregates.total_orders?.toLocaleString() || 0}
                </div>
              </div>

              {/* 10. Revenue Column - Total GMV */}
              <div className="col-1 text-center d-flex flex-column justify-content-center">
                {/* Title */}
                <div className="tw-text-[7px] md:tw-text-[9px] tw-font-bold">
                  общ. выручка
                </div>
                {/* Value */}
                <div className="tw-text-[6px] md:tw-text-[8px] tw-pt-1 tw-text-blue-400 tw-font-bold">
                  {aggregates.total_gmv
                    ? `${aggregates.total_gmv.toLocaleString()} ₸`
                    : "0 ₸"}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Monthly Graph Popup */}
      <MonthlyGraphPopup
        isOpen={isGraphPopupOpen}
        onClose={handleCloseGraphPopup}
        monthlyData={monthlyData}
        filters={filters}
      />
    </div>
  );
};
